import { Text, View } from '@react-pdf/renderer';

/**
 *
 * @exports function ContactsInformation
 *
 * @description Export contact information of the company as a React Component
 *
 * @param { Object } legalData - legal data with contact information of the company
 *
 * @returns { JSX.Element }
 *
 */

export default function ContactsInformation ( { legalData } ) {

    /**
     *
     * @description
     *
     * Render contact information of the company as a React Component
     *
     * @returns { JSX.Element }
     *
     */

    return (

        <View>

            <Text style={ { marginBottom: 5, fontWeight: 500 } }>Kontakti</Text>

            <Text>Veikals:

                <Text style={ { textDecoration: "underline" } }> { legalData?.phone || "-" }</Text>

            </Text>

            <Text>Serviss:

                <Text style={ { textDecoration: "underline" } }> { legalData?.servicePhone || "-" }</Text>

            </Text>

            <Text>E-Pasts: { legalData?.email || "-" }</Text>

        </View>

    );

};